export function msMinutes(minutes) {
    return minutes * 60 * 1000;
}
